export const formatDecimalNumber = (value: number | null | undefined): string => {
    return value ? value.toFixed(2).replace(/[.,]00$/, "") : "";
};

export function formatNumber(num: number | null | undefined): string {
    if (!num) return "";
    if (num >= 10000) {
        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: num % 1 === 0 ? 0 : 2, // Show decimals only if necessary,
            maximumFractionDigits: 2,
        }).format(num);
    }
    return num.toString();
}
